import { LandingPage } from '@repo/loyalty-program-ui/src/components/landing-page/LandingPage/LandingPage';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider, initReactI18next } from 'react-i18next';

import { CartProvider } from '@zooplus/cart-provider';
import {
  findLocaleFromUrlAndCookie,
  findSiteByDomain,
  findSiteFromUrl,
  findStageFromUrl,
  findCDNBaseUrlFromUrl,
  LOCALES,
  SiteProvider,
} from '@zooplus/commons-lang';

const WRAPPER_LANDING = document.getElementById(
  'loyalty-management-landing-wrapper',
) as HTMLElement;

const site = findSiteFromUrl() || findSiteByDomain('zooplus.com');
const locale = findLocaleFromUrlAndCookie() || 'en-GB';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    partialBundledLanguages: true,
    backend: {
      reloadInterval: false,
      loadPath: (lng: string, ns: string[]) =>
        `${findCDNBaseUrlFromUrl()}/media/${ns}/${lng[0]}.json`,
    },
    lng: locale,
    load: 'currentOnly',
    ns: [],
    defaultNS: false,
    fallbackLng: 'en-GB',
    debug: true,
    supportedLngs: [...LOCALES, 'zu'],
    interpolation: {
      escapeValue: false,
    },
  });

if (WRAPPER_LANDING) {
  const root = createRoot(WRAPPER_LANDING);
  const isCustomerLoggedIn = !!WRAPPER_LANDING.dataset.customerId;
  const stage = findStageFromUrl();

  root.render(
    <Suspense fallback={null}>
      <I18nextProvider i18n={i18n}>
        <SiteProvider site={site} locale={locale}>
          <CartProvider stage={stage}>
            <LandingPage isCustomerLoggedIn={isCustomerLoggedIn} />
          </CartProvider>
        </SiteProvider>
      </I18nextProvider>
    </Suspense>,
  );
}
